import { ServiceException } from '@inter-ikea-kompis/exceptions';
import { LocaleUtility } from '@inter-ikea-kompis/utilities';
import ServiceFetch from '../../utilities/ServiceFetch.js';
import TranslationsTransformer from './TranslationsTransformer.js';
/**
 * This service is used for fetching and transforming translations.
 */
export default class InternalTranslationsService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.translationPrefixApplication Translation prefix application.
     * @param options.translationEndpoints Translation endpoints.
     * @param options.locale Locale.
     */
    constructor(options) {
        this.translationPrefixApplication = options.translationPrefixApplication;
        this.translationEndpoints = options.translationEndpoints;
        this.locale = options.locale;
    }
    /**
     * Fetches and returns translations.
     *
     * @returns Promise object.
     */
    async getTranslations() {
        const responses = await Promise.all(this.translationEndpoints.map((url) => this.fetch(url)));
        const transformer = new TranslationsTransformer({
            translationPrefixApplication: this.translationPrefixApplication
        });
        const transformed = responses.map((response) => transformer.transform(response));
        return this.mergeTranslations(transformed);
    }
    /**
     * Merges multiple translations.
     *
     * @param translations Array of translations.
     * @returns Merged translations.
     */
    mergeTranslations(translations) {
        const merged = Object.assign({}, ...translations);
        for (const key of Object.keys(merged)) {
            merged[key] = Object.assign({}, ...translations.map((translations) => translations[key]));
        }
        return merged;
    }
    /**
     * Fetches and returns translations.
     *
     * @param url URL.
     * @returns Promise object.
     */
    async fetch(url) {
        const { country, language } = LocaleUtility.getCountryAndLanguage(this.locale);
        if (!country || !language) {
            throw new ServiceException('Country or language is not defined. Format locale correctly, e.g. en-GB');
        }
        const parsedUrl = url
            .replace('{country}', country.toUpperCase())
            .replace('{language}', language);
        return await ServiceFetch.json(parsedUrl, {
            credentials: 'same-origin'
        });
    }
}
//# sourceMappingURL=InternalTranslationsService.js.map